//  const BASEURL = 'https://abdmapi.lalpathlabs.com/';
// const BASEURL = "https://abdm-api.pathkindlabs.com/";
// const BASEURL = "http://localhost:8093/";
// const BASEURL = "https://abha.abym.us/";
const BASEURL = "https://uat-apis-abymabdm.abym.us/";
//const BASEURL = 'https://uat-abdmapi.lalpathlabs.com/';
const API_URL = {
  BASEURL: BASEURL,
  API_BASEURL: `${BASEURL}api/v1/`,
  IMAGE_URL: BASEURL,
  LOGIN_AUTH: `auth/get-time`,
  LOGIN: `auth/signin`,
  DASHBOARD_FAQ_COUNT: `/dashboard/faqs/count`,
  DASHBOARD_USER_COUNT: `/dashboard/users/count`,
  DASHBOARD_JOB_ADD_COUNT: `/dashboard/jobs/count`,
  USER_LIST: `/users/list`,
  USER_ADD: `/users/add`,
  USER_UPDATE: `/users/update`,
  USER_STATUS_UPDATE: `/users/update/status`,
  UPDATE_PASSWORD: `/users/changepassword`,
  USER_BY_ID: `/users/details`,
  ROLE_LIST: `/role/list`,
  ROLE_ADD: `/role/add`,
  ROLE_UPDATE: `/role/update`,
  ROLE_BY_ID: `/role/details`,
  FILTER_DATA: "/role/filterdata",
  PERMISSION_UPDATE: "/role/updatepermissions",
  MY_PERMISSIONS: "/role/my-permissions",
  ABHA_CREATED_LIST: `admin/getCardLogs`,
  ABHA_LINK_NOTIFY: `hip/v2/link-record`,
  ABDM_UPLOAD_FILE: `s3/upload/file`,
  ABDM_HIP_AUTH_LIST: `hip/list/auth-confirm-logs`,
  // Admin login route (abha/patientAbhaCardsLogs needs the patient app session)
  PATIENT_ABHA_LIST: `admin/abhaCardsLogs`,
  PATIENT_REPORT_LIST: `/hip/list/patient-report`,
  HEALTH_INFORMATION_REQUEST: `hiu/health-information-request`,
  DOWNLOAD_REPORT: `hiu/data-decryption2`,
  DECODE_BASE64: `upload/base64ToPdf`,
  UPLOADREPORT: `/abha/add/patient-reports`,
  ACTIVE_FACILITIES: `/admin/facilities/active`,
  GET_REPORT_PDF: `/users/downloadReportPdf`,
  LOG_OUT: "/users/signout",
  AUDIT_LOGS: "/admin/getAbhaLogs",
  // Organizations (super admin: all; others: own + the ones they created)
  ORGANIZATION_LIST: "/organizations/list",
  ORGANIZATION_ADD: "/organizations/add",
  ORGANIZATION_UPDATE: "/organizations/update",
  ORGANIZATION_STATUS_UPDATE: "/organizations/update/status",
  ORGANIZATION_BY_ID: "/organizations/details",
  // Facilities of an organization: /organizations/:id/facilities/...
  ORGANIZATION_FACILITIES: (id) => `/organizations/${id}/facilities`,
  // Partner API integrations of an organization: /organizations/:id/integrations/...
  ORGANIZATION_INTEGRATIONS: (id) => `/organizations/${id}/integrations`,
  // Partner API token: /organizations/:id/token and /token/regenerate
  ORGANIZATION_TOKEN: (id) => `/organizations/${id}/token`,
  FACILITY_TOKEN: (id, facilityId) => `/organizations/${id}/facilities/${facilityId}/token`,
};
export default API_URL;
